/*
  ves-video-facade.js

  Global click-to-load handler for every ves-video-facade on any page.
  Previously this lived in ves-demo-video.liquid's section JS, so facades
  on pages without that section (hero trailers on bundle PDPs) never
  played. Delegated so it also covers facades rendered after load.
*/

(function () {
  'use strict';
  if (window.__vesFacadeInit) return;
  window.__vesFacadeInit = true;

  function load(facade) {
    var id = facade.dataset.videoId;
    if (!id || facade.dataset.vesLoaded === '1') return;
    facade.dataset.vesLoaded = '1';
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&enablejsapi=1&origin=' + encodeURIComponent(location.origin);
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.title = facade.getAttribute('aria-label') || 'Video player';
    facade.replaceChildren(iframe);
  }

  document.addEventListener('click', function (e) {
    var f = e.target.closest && e.target.closest('.ves-video-facade[data-video-id]');
    if (f) load(f);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var f = e.target.closest && e.target.closest('.ves-video-facade[data-video-id]');
    if (f && e.target === f) {
      e.preventDefault();
      load(f);
    }
  });
})();
